<template>
  <div
    v-if="isInitEnd"
    class="tab-card"
    :class="{ 'tab-card--is-inxbb-quick-view': inxbbQuickView }"
    :style="{ minHeight: tabHieght }"
  >
    <van-sticky v-if="!isDrawer" :offset-top="inxbbQuickView ? -8 : 60 + statusBarHeight">
      <div style="height: 8px; width: 100%"></div>
      <van-tabs v-model:active="activeName" shrink>
        <van-tab v-for="tab in tabs" :key="tab.key" :name="tab.key" :title="tab.name"></van-tab>
      </van-tabs>
    </van-sticky>
    <template v-else>
      <div style="height: 8px; width: 100%"></div>
      <van-tabs v-model:active="activeName" shrink>
        <van-tab v-for="tab in tabs" :key="tab.key" :name="tab.key" :title="tab.name"></van-tab>
      </van-tabs>
    </template>
    <div class="detail-content">
      <template v-if="activeName === 'asr'">
        <AiDetailTalkMobile
          :chat-list="chatList"
          :inxbb-quick-view="inxbbQuickView"
          :is-audio="isAudio"
          @startWithTime="handleStartWithTime"
        />
      </template>
      <template v-else-if="activeName === 'quality'">
        <AnalysisCard
          v-if="riskResult"
          :behaving-id="behavingId"
          :quality-analysis-info="qualityAnalysisInfo"
          :suggestion="suggestion"
          :yk-type="ykType"
          @handleRefresh="handleRefresh"
          @startWithTime="handleStartWithTime"
        />
      </template>
      <template v-else-if="activeName === 'followup'">
        <Empty
          v-if="+activeStage.kind === 2 && +activeStage.sourceType === 3"
          :empty-text="uselessTittle"
        />
        <template v-else>
          <div v-if="url" class="top-desc">
            <span class="label">会议链接</span>
            <div class="meeting-url" @click="handleOpenUrl">
              <span>会议链接</span>
              <i class="icon-arrow-right-s-line t-iconfont"></i>
            </div>
          </div>
          <template v-if="isLiberalRules">
            <MarkdownView :show-string="communicateContents" />
          </template>
          <template v-else>
            <div class="content-box" v-html="showTextContent"></div>
          </template>
        </template>
      </template>
      <template v-else-if="activeName === 'suggestion'">
        <div v-if="isActionStrategyConfigEnable" class="unenableSuggest">
          <img alt="AI助手logo" src="@/assets/chatbot.svg" />
          <span>当前跟进未启用本项分析</span>
        </div>
        <template v-else>
          <Empty v-if="+activeStage.kind === 2" :empty-text="uselessTittle" />
          <NextStepCard
            v-else
            :ai-recommend-plan="aiRecommendPlan"
            :attributes="aiMeetingExecuteStrategy"
            in-detail
            :recommend-task-enable="recommendTaskEnable"
            @removeData="removeData"
          />
        </template>
      </template>
      <template v-else-if="activeName === 'employee'">
        <Empty v-if="+activeStage.kind === 2" :empty-text="uselessTittle" />
        <EmployeePerformance
          v-else
          :data-info="employeeBehaviorInfo"
          :has-enable-rule="hasEnableRule"
          is-mobile
          :status="analyzingStatus"
          @preview="handlePreview"
        ></EmployeePerformance>
      </template>
      <template v-else-if="activeName === 'session-archive'">
        <div class="session-archive__nothing">
          <span>请在PC端查看聊天记录内容</span>
        </div>
      </template>
      <template v-else-if="activeName === 'chat-archive'">
        <div class="session-archive__nothing">
          <span>请在PC端查看聊天记录内容</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { isMobile } from '@/utils'
import AnalysisCard from './analysis-card.vue'
import AiDetailTalkMobile from './ai-detail-talk-mobile.vue'
import NextStepCard from '@/components/Cards/RelaVisitorCard.vue'
import MarkdownView from '@/components/markdown-view/index.vue'
import { useSystemSetStore } from '@/store/systemSet'
import Empty from '@/components/Empty/index.vue'
import EmployeePerformance from '@/pages/ai-board/employee-performance/index.vue'

const emit = defineEmits(['preview', 'startWithTime', 'handleRefresh', 'removeData'])
const props = defineProps({
  communicateContents: {
    type: String,
    default: ''
  },
  meetingDuration: {
    type: String,
    default: ''
  },
  url: {
    type: String,
    default: ''
  },
  dataList: {
    type: Array,
    default: () => []
  },
  riskResult: {
    type: String,
    default: ''
  },
  isAudio: {
    type: Boolean,
    default: false
  },
  chatList: {
    type: Array,
    default: () => []
  },
  // 拜访记录id
  behavingId: {
    type: Number,
    default: 1
  },
  // 质量分析信息
  qualityAnalysisInfo: {
    type: Object,
    default: () => ({})
  },
  aiMeetingExecuteStrategy: {
    type: Object,
    default: null
  },
  inxbbQuickView: {
    type: Boolean,
    default: false
  },
  isLiberalRules: {
    type: Number,
    default: 0
  },
  activeStage: {
    type: Object,
    default: () => ({})
  },
  employeeBehaviorInfo: {
    type: Object,
    default: () => ({})
  },
  analyzingStatus: {
    type: String,
    default: ''
  },
  suggestion: {
    type: String,
    default: ''
  },
  ykType: {
    type: String,
    default: ''
  },
  recommendTaskEnable: {
    type: Boolean,
    default: false
  },
  aiRecommendPlan: {
    type: Array,
    default: () => []
  },
  isDrawer: {
    type: Boolean,
    default: false
  },
  // 是否存在会话存档tab
  isSessionArchive: Boolean
})
const systemStore = useSystemSetStore()
// 是否未开启任何行动策略配置
const isActionStrategyConfigEnable = computed(() => {
  return !systemStore.linkCommunicatePlanEnable && !systemStore.refiningCommunicatePlanEnable
})

const uselessTittle = computed(() => {
  return props.qualityAnalysisInfo.staffRiskResult || props.qualityAnalysisInfo.riskResult
})

const statusBarHeight =
  parseInt(getComputedStyle(document.documentElement).getPropertyValue('--status-bar-height')) || 0

const isInitEnd = ref(false)
const activeName = ref('')
const tabHieght = ref('100%')
const tabs = ref([
  // { name: '质量分析', key: 'quality' },
  // { name: '跟进内容', key: 'followup' },
  // { name: '本次表现', key: 'performance' }
])

const hasEnableRule = computed(() => {
  return systemStore.hasEnableRule
})

const showTextContent = computed(() => {
  const replacedText = props.communicateContents
    .replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold;color: #323233;">$1</span>')
    .replace(/\n/g, '<br>')
  return replacedText
})

const handleStartWithTime = (time) => {
  emit('startWithTime', time)
}

const removeData = (index) => {
  emit('removeData', index)
}

const handleOpenUrl = () => {
  if (isMobile()) {
    emit('preview', props.url)
  } else {
    window.open(props.url, '_blank')
  }
}

const handlePreview = (url) => {
  emit('preview', url)
}

/**
 * 刷新数据
 */
const handleRefresh = () => {
  emit('handleRefresh')
}
/**
 * 初始化tab
 */
const initTab = () => {
  const allTabs = [
    { name: '质量分析', key: 'quality' },
    { name: '跟进内容', key: 'followup' },
    { name: '员工表现', key: 'employee' },
    // { name: '本次表现', key: 'performance' },
    { name: '行动建议', key: 'suggestion' }
  ]
  let filteredTabs = allTabs.filter((item) => {
    if (
      item.key === 'suggestion' &&
      !systemStore.linkCommunicatePlanEnable &&
      !systemStore.refiningCommunicatePlanEnable
    ) {
      return false
    }
    // 过滤员工表现
    return !(item.key === 'employee' && !systemStore.isEmployeePerform)
  })
  // 1: 跟进助手,2: 跟进记录（CRM）,3: 呼叫中心-销帮帮
  const sourceType = props.qualityAnalysisInfo?.sourceType
  // 同web端逻辑
  if (sourceType === 2) {
    filteredTabs = filteredTabs.filter((item) =>
      ['quality', 'followup', 'suggestion'].includes(item.key)
    )
  }
  // 最终赋值
  tabs.value = filteredTabs
  // 如果有语音转文字数据，则在最前面插入一个tab
  if (props.chatList.length && props.ykType !== 'ykWechat') {
    tabs.value.unshift({ name: '会话原文', key: 'asr' })
  }
  // 如果有会话存档tab
  if (props.isSessionArchive) {
    tabs.value.push({ name: '会话聊天记录', key: 'session-archive' })
  }
  // 如果有会话存档tab
  if (props.ykType === 'ykWechat') {
    // 在跟进内容前面插入一个tab
    const followupIndex = tabs.value.findIndex((item) => item.key === 'followup')
    // tabs.value.splice(followupIndex, 0, { name: '聊天记录', key: 'chat-archive' })
    const name = props.activeStage.sourceType === 11 ? '微信群聊' : '微信单聊'
    tabs.value.splice(followupIndex, 0, { name, key: 'chat-archive' })
  }
}

onMounted(async () => {
  await systemStore.getIsActionAdvice()
  await systemStore.getIsEmployeePerform()
  initTab()
  // 获取元素 visit-path-detail 的高度
  let bottom = 0
  if (props.isAudio) {
    bottom += 52
  }
  if (props.inxbbQuickView) {
    bottom -= 16
  }
  tabHieght.value = document.querySelector('.visit-path-detail').clientHeight - bottom + 'px'
  activeName.value = tabs.value[0].key
  isInitEnd.value = true
})

defineExpose({
  isInitEnd
})
</script>

<style lang="scss" scoped>
.tab-card {
  box-sizing: border-box;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  overflow: hidden;
  background: #f2f3f5;
  border-color: #f2f3f5;
  border-style: solid;
  /* 线条/Line-1 浅线条 */
  /* 样式描述：$neutral-color-2 */
  border-width: 0px 0px 1px 0px;
  :deep(.van-sticky) {
    background: #f2f3f5;
  }
  :deep(.van-tabs__wrap) {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom: 1px solid #e5e6eb;
  }
  :deep(.van-tabs__line) {
    background: #7a52f4;
  }
  .detail-content {
    flex: 1;
    padding: 8px;
    line-height: 20px;
    background-color: #ffffff;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    :deep(.el-scrollbar__view) {
      display: flex;
      flex-direction: column;
      padding: 0;
    }
    .top-desc {
      display: flex;
      margin-bottom: 8px;
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 20px;
      .label {
        flex: 0 0 84px;
        margin-right: 12px;
        color: #646566;
      }
      .meeting-duration {
        color: #323233;
      }
      .meeting-url {
        display: flex;
        color: #248df5;
        cursor: pointer;
        i {
          margin-left: 4px;
          font-size: 16px;
        }
      }
    }
    .content-box {
      padding: 8px;
      background: #f7f8fa;
      border-radius: 8px;
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 20px;
      color: #323233;
    }
    .behavior-box {
    }
    .empty-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #323233;
    }
    .unenableSuggest {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 12px 0;
      font-size: 14px;
      font-family: PingFang SC;
      color: #969799;
    }
    // 会话存档tab
    .session-archive__nothing {
      width: 100%;
      height: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #969799;
      font-size: 14px;
    }
  }
}
.tab-card--is-inxbb-quick-view {
  background: unset;
  :deep(.van-sticky) {
    background: unset;
  }
}
</style>
